import React from 'react'
import GaugeTile from './GaugeTile'
import NumberTile from './NumberTile'
import TrendTile from './TrendTile'
import BreakdownTile from './BreakdownTile'

// Renders any server KPI descriptor. The server defines what exists; the
// client only knows how to draw the four tile types.
const KPITile = ({ kpi }) => {
  switch (kpi.type) {
    case 'gauge':
      return <GaugeTile kpi={kpi} />
    case 'number':
      return <NumberTile kpi={kpi} />
    case 'trend':
      return <TrendTile kpi={kpi} />
    case 'breakdown':
      return <BreakdownTile kpi={kpi} />
    default:
      return null
  }
}

export default KPITile
